import { createTreeURLParams, TreeNode } from "@fidelix/fx-miranda";

const SELECTED_COMPANY = "selectedCompanyId";

export const setCompanyToLocalStorage = (value: number | string) => {
  localStorage.setItem(SELECTED_COMPANY, String(value));
};

export const getCompanyFromLocalStorage = () => {
  return localStorage.getItem(SELECTED_COMPANY);
};

export const clearTreeParams = (params: URLSearchParams) => {
  params.delete("node");
  params.delete("graphicsId");
  params.delete("graphic");
  params.delete("path");
};

export function createGraphicsNavigationParams({
  currentNode,
  graphicPath,
}: {
  currentNode: TreeNode;
  graphicPath?: string | null;
}): URLSearchParams {
  const params = new URLSearchParams(
    createTreeURLParams({ currentNode, graphicPath }),
  );
  params.set("treeKey", String(Date.now()));
  return params;
}
